import {Injectable, NgZone} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {GoogleGeometry} from '../models';
declare var google: any;

@Injectable()
export class GeocoderService {

	constructor(private ngZone: NgZone) {
	}

	createGeocoderAddress(street: string, housenumber: string, city: string, postalcode: string, country: string): string {
		let address = "";
		if (street) address += street + " "
		if (housenumber) address += housenumber + " "
		if (postalcode) address += postalcode + " "
		if (city) address += city + " "
		if (country) address += country + " "
		address = address.substr(0, address.length - 1)
		return address
	}

	public getGeometry(street: string, housenumber: string, city: string, postalcode: string, country: string): Observable<GoogleGeometry> {

		let geocoder = new google.maps.Geocoder();
		let address: string = this.createGeocoderAddress(street, housenumber, city, postalcode, country)

		return Observable.create(observer => {
			geocoder.geocode({ 'address': address }, (results, status) => {
				this.ngZone.run(() => {
					let googleGeometry: GoogleGeometry = new GoogleGeometry();
					googleGeometry.location = {
						lat: results[0].geometry.location.lat(),
						lng: results[0].geometry.location.lng()
					}
					observer.next(googleGeometry)
					observer.complete();
				})
			});
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/services/geocoder.service.ts